import {
  BrowserAuthError,
  InteractionRequiredAuthError,
} from '@azure/msal-browser';
import { useMsal } from '@azure/msal-react';

export const microsoftLoginRequest = {
  // See: https://learn.microsoft.com/en-us/onedrive/developer/controls/file-pickers/?view=odsp-graph-online#permissions
  scopes: ['Files.ReadWrite', 'User.Read'],
  prompt: 'select_account',
};

const useGetMicrosoftAccessToken = (): (() => Promise<string>) => {
  const { instance: msalInstance } = useMsal();

  const getMicrosoftAccessToken = async (): Promise<string> => {
    try {
      const tokenResponse = await msalInstance.acquireTokenSilent(
        microsoftLoginRequest,
      );

      return tokenResponse.accessToken;
    } catch (error) {
      if (
        !(error instanceof InteractionRequiredAuthError) &&
        !(error instanceof BrowserAuthError)
      ) {
        throw error;
      }

      const loginResponse = await msalInstance.loginPopup(
        microsoftLoginRequest,
      );

      msalInstance.setActiveAccount(loginResponse.account);

      return loginResponse.accessToken;
    }
  };

  return getMicrosoftAccessToken;
};

export default useGetMicrosoftAccessToken;
